import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Svg from './Svg';

class Main extends Component {
  render() {
    const { darkMode, iconsData } = this.props;

    return (
      <main className={`main ${darkMode ? "dark-mode" : ""}`} id="main">

        <div className="main__inner">
          <style>{`
            content {
              color: ${iconsData.iconsColor};
            }
            .ikonate {
              display: block;
              width: ${iconsData.iconsWidth}px;
              height: ${iconsData.iconsWidth}px;
              stroke: ${iconsData.iconsColor};
              stroke-width: ${iconsData.iconsBorder*24/iconsData.iconsWidth};
              stroke-linecap: ${iconsData.iconsLinecap};
              stroke-linejoin: ${iconsData.iconsJoin};
              fill: none;
            }
          `}</style>

          {this.getAllSvgs(iconsData.listOfSvgs)}
        </div>
      </main>
    );
  }

  getAllSvgs(list){
      const matchingSvgs = this.findSearchIcons()
      const showAll = !matchingSvgs

      return list.map((i, index)=>{
          if (!Array.isArray(this.props.selectedSvgs)){
            window.Rollbar && window.Rollbar.warning('selectedSvgs is not an Array!')
          }
          const isSelected = this.props.selectedSvgs.find( (current)=>{ return i === current } )

          return showAll || matchingSvgs.find((current)=>{return current === i}) ?
                          <Svg svgName={i} index={index} selectSvg={this.props.selectSvg} isSelected={isSelected} key={index} />
                          :
                          ""
      })
  }

  findSearchIcons(){
      const keyWords = this.props.keyWords
      const searchKey = this.props.searchKey.replace(/^[ ]+|[ ]+$/g,'').replace(/\s\s+/g, ' ')
      //First regEx delete spaces on at the beginning and end of line
      //Second regEx reduce multiple spaces to single
      const matchingSvgs = []

      if(searchKey.length <= 0 || !keyWords){
          return;
      }

      for(const i in keyWords){
          if(keyWords[i].includes(searchKey)){
              matchingSvgs.push(i)
          }
      }

      return matchingSvgs
  }
}

Main.propTypes = {
  selectedSvgs: PropTypes.array.isRequired,
  searchKey: PropTypes.string,
  keyWords: PropTypes.object,
};

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js